import {
  IUserRepository,
  GetCurrentUserResponse,
} from "~/core/domain/repositories/user-repository.interface";
import { BACKEND_API_URL } from "~/constants";
import { getAuthorizationHeaders } from "~/infra/auth/client";

export class BackendUserRepository implements IUserRepository {
  async getCurrentUser(): Promise<GetCurrentUserResponse> {
    const url = new URL(`${BACKEND_API_URL}/v1/users/me`);

    const authHeaders = await getAuthorizationHeaders();
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      ...authHeaders,
    };

    const response = await fetch(url.toString(), {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({
        detail: "ユーザー情報の取得に失敗しました",
      }));
      const err = new Error(
        error.detail || "ユーザー情報の取得に失敗しました"
      ) as Error & { status?: number };
      err.status = response.status;
      throw err;
    }

    const data = await response.json();
    return data;
  }
}
